<template>
  <WarningAlert class="d-md-flex justify-content-md-center">
    <p class="mb-0">
      <span class="fw-semibold d-block d-md-inline mr-md-8">
        {{ $label('books.notAvailableAlert.notAvailableText') }}
      </span>
      <span class="d-block d-md-inline mb-16 mb-md-0 mr-md-8">
        {{
          $label('books.notAvailableAlert.availableInMonthText', { bookMonth })
        }}
      </span>
      <NuxtLink v-if="!loggedInUser" :to="pages.register">
        <span>
          {{ $label('books.notAvailableAlert.becomeMemberLink') }}
        </span>
      </NuxtLink>
    </p>
  </WarningAlert>
</template>

<script>
import WarningAlert from '~/components/alerts/WarningAlert'
import dateFormatter from '~/utils/dateFormatter'
import { PAGES } from '~/utils/constants'

export default {
  components: {
    WarningAlert,
  },
  props: {
    categoryCode: {
      type: String,
      required: true,
    },
    loggedInUser: {
      type: [Object, Boolean],
      default: false,
    },
  },
  computed: {
    bookMonth() {
      return dateFormatter(this.categoryCode, {
        day: undefined,
      })
    },
    pages() {
      return PAGES
    },
  },
}
</script>
